import React, { ReactNode } from 'react';
import STTypo from '../typo/STTypo';
import { TypeOptions } from '../typo/STTypo.models';

import './button.style.scss';

export interface GoToButtonProps {
  readonly ariaLabel: string;
  readonly text: string | ReactNode;
  readonly icon?: ReactNode;
  readonly onClick: Function;
  readonly className?: string;
  readonly disabled?: boolean;
  readonly bold?: boolean;
  readonly type?: TypeOptions;
}

const TextButton = ({
  ariaLabel,
  text,
  icon = null,
  onClick,
  className = '',
  disabled = false,
  bold = false,
  type = TypeOptions.P2
}: GoToButtonProps) => {
  return (
    <button onClick={() => onClick()} className={`text-button ${className}`} disabled={disabled}>
      {icon && <span className='text-button__icon'>{icon}</span>}
      <STTypo aria-label={ariaLabel} type={type} bold={bold}>
        {text}
      </STTypo>
    </button>
  );
};

export default TextButton;
